module.exports = __webpack_public_path__ + "static/media/md-mail.cdb6a206.svg";